module.exports = __webpack_public_path__ + "img/logo-sub-console.c03347a4.svg";